
document.addEventListener('DOMContentLoaded', function () {
  const detailsElements = document.querySelectorAll('#mega-menu-mega_menu_tUKdpC details');
  if (detailsElements.length > 0) {
    detailsElements[0].setAttribute('open', '');
    detailsElements.forEach(details => {
      details.addEventListener('toggle', function () {
        const isAnyOpen = Array.from(detailsElements).some(detail => detail.open);
        if (!isAnyOpen) {
          detailsElements[0].setAttribute('open', '');
        }
      });
    });
  }
});


document.addEventListener('DOMContentLoaded', function () {
  const detailsElements = document.querySelectorAll('.toggle-info-section-container details');
  if (detailsElements.length > 0) {
    detailsElements[0].setAttribute('open', '');
    detailsElements.forEach(details => {
      details.addEventListener('toggle', function () {
        const isAnyOpen = Array.from(detailsElements).some(detail => detail.open);
        if (!isAnyOpen) {
          detailsElements[0].setAttribute('open', '');
        }
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
    // Funzione per applicare le classi una volta che l'elemento è disponibile
    function applyFilters() {
        const filterContainer = document.querySelector('div[data-filter-type="Collection"]');

        if (filterContainer) {
            const listItems = filterContainer.querySelectorAll('ul.gf-option-box > li[data-collection]');

            listItems.forEach(li => {
                li.classList.add("is-collapsed");

                const childUl = li.querySelector("ul");
                if (childUl) {
                    childUl.classList.add("nascosto");
                }
            });

            // Una volta applicate le modifiche, possiamo disconnettere l'osservatore
            observer.disconnect();
        }
    }

    // Crea un MutationObserver per rilevare quando l'elemento appare nel DOM
    const observer = new MutationObserver(() => {
        if (document.querySelector('div[data-filter-type="Collection"]')) {
            applyFilters();
        }
    });

    // Osserva le modifiche nel body dell'HTML
    observer.observe(document.body, { childList: true, subtree: true });
});


document.addEventListener("DOMContentLoaded", function () {
    // Seleziona tutti gli elementi <details>
    const detailsElements = document.querySelectorAll(".toggle-info-section-container details");

    detailsElements.forEach(details => {
        details.addEventListener("toggle", function () {
            if (details.open) { // Controlla se il <details> è stato aperto
                setTimeout(() => {
                    details.scrollIntoView({ behavior: "smooth", block: "start" });
                }, 300); // Aggiunto un piccolo delay per evitare problemi di rendering
            }
        });
    });
});



